module.exports = __webpack_public_path__ + "static/media/facebook.94d872ac.svg";